import React, { useState, useMemo } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';



const AnmerkningerTable = (props) => {

    const localeMessages = props.localeMessages;
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;


    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('kreditor');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )

    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
        <thead>
          <tr>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('creditor', 'string')}>{localeMessages['GH_kreditor']}{t1IndicaterIcon('creditor')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('caseNumber', 'string')}>{localeMessages['GH_saksnummer']}{t1IndicaterIcon('caseNumber')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registrationDate', 'datetime')}>{localeMessages['GH_registreringsdato']}{t1IndicaterIcon('registrationDate')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('settlementStatus', 'string')}>{localeMessages['GH_oppgjoersstatus']}{t1IndicaterIcon('settlementStatus')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('settlementDate', 'datetime')}>{localeMessages['GH_oppgjoersdato']}{t1IndicaterIcon('settlementDate')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('collectionAgency', 'string')}>{localeMessages['GH_inkassobyraa']}{t1IndicaterIcon('collectionAgency')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('typeCode', 'string')}>{localeMessages['GH_typekode']}{t1IndicaterIcon('typeCode')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('typeDescription', 'string')}>{localeMessages['GH_typebeskrivelse']}{t1IndicaterIcon('typeDescription')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('caseEventType', 'string')}>{localeMessages['GH_sakshendelsetype']}{t1IndicaterIcon('caseEventType')}</th>
            <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('amount', 'string')}>{localeMessages['GH_beloep']}{t1IndicaterIcon('amount')}</th>
            </tr>
        </thead>
      )
    }


    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <KredittvurderingTd>{model.creditor}</KredittvurderingTd>
               <KredittvurderingTd>{model.caseNumber}</KredittvurderingTd>
               <KredittvurderingTd>{model.registrationDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.settlementStatus}</KredittvurderingTd>
               <KredittvurderingTd>{model.settlementDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.collectionAgency}</KredittvurderingTd>
               <KredittvurderingTd>{model.typeCode}</KredittvurderingTd>
               <KredittvurderingTd>{model.typeDescription}</KredittvurderingTd>
               <KredittvurderingTd>{model.caseEventType}</KredittvurderingTd>
               <KredittvurderingTd>{model.amount}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Anmerkninger</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default AnmerkningerTable



